var _feFlood, _feComposite, _feGaussianBlur, _feOffset, _feComposite2, _feFlood2, _feComposite3, _feGaussianBlur2, _feOffset2, _feComposite4, _feFlood3, _feComposite5, _feGaussianBlur3, _feOffset3, _feComposite6, _feFlood4, _feComposite7, _feGaussianBlur4, _feOffset4, _feComposite8, _linearGradient, _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    id: "svg24",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs28"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient10021"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 0
    },
    offset: 0,
    id: "stop10017"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 0.18334907
    },
    offset: 0.13188708,
    id: "stop10639"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#170721",
      stopOpacity: 0
    },
    offset: 0.3291136,
    id: "stop10379"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 0
    },
    offset: 0.36023462,
    id: "stop12478"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 0.18431373
    },
    offset: 0.51114511,
    id: "stop13170"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#7b7281",
      stopOpacity: 0
    },
    offset: 0.68229651,
    id: "stop13785"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#625769",
      stopOpacity: 0
    },
    offset: 0.73836452,
    id: "stop13979"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 0.18431373
    },
    offset: 0.90387034,
    id: "stop21094"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#170721",
      stopOpacity: 0
    },
    offset: 1,
    id: "stop10019"
  })), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter37483",
    x: -1.6608631e-8,
    y: -1.058908e-8,
    width: 1.0387064,
    height: 1.1101508
  }, _feFlood || (_feFlood = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 1,
    floodColor: "rgb(0,0,0)",
    result: "flood",
    id: "feFlood37473"
  })), _feComposite || (_feComposite = /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1",
    id: "feComposite37475"
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    stdDeviation: 0,
    result: "blur",
    id: "feGaussianBlur37477"
  })), _feOffset || (_feOffset = /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.14106,
    dy: 3.24326,
    result: "offset",
    id: "feOffset37479"
  })), _feComposite2 || (_feComposite2 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    operator: "over",
    result: "composite2",
    id: "feComposite37481"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter4456",
    x: -0.20657292,
    y: -0.065867718,
    width: 1.4600433,
    height: 1.1860886
  }, _feFlood2 || (_feFlood2 = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 1,
    floodColor: "rgb(0,0,0)",
    result: "flood",
    id: "feFlood4446"
  })), _feComposite3 || (_feComposite3 = /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1",
    id: "feComposite4448"
  })), _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    stdDeviation: 1.63764,
    result: "blur",
    id: "feGaussianBlur4450"
  })), _feOffset2 || (_feOffset2 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.89229,
    dy: 3.24326,
    result: "offset",
    id: "feOffset4452"
  })), _feComposite4 || (_feComposite4 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    operator: "over",
    result: "composite2",
    id: "feComposite4454"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter20914",
    x: -0.14393916,
    y: -0.089723612,
    width: 1.3403561,
    height: 1.2074859
  }, _feFlood3 || (_feFlood3 = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 1,
    floodColor: "rgb(0,0,0)",
    result: "flood",
    id: "feFlood20904"
  })), _feComposite5 || (_feComposite5 = /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1",
    id: "feComposite20906"
  })), _feGaussianBlur3 || (_feGaussianBlur3 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    stdDeviation: 0.8,
    result: "blur",
    id: "feGaussianBlur20908"
  })), _feOffset3 || (_feOffset3 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.7,
    dy: 0.6,
    result: "offset",
    id: "feOffset20910"
  })), _feComposite6 || (_feComposite6 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    operator: "over",
    result: "composite2",
    id: "feComposite20912"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter21709",
    x: -0.030670947,
    y: -0.067780632,
    width: 1.0540393,
    height: 1.1567427
  }, _feFlood4 || (_feFlood4 = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 1,
    floodColor: "rgb(0,0,0)",
    result: "flood",
    id: "feFlood21699"
  })), _feComposite7 || (_feComposite7 = /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1",
    id: "feComposite21701"
  })), _feGaussianBlur4 || (_feGaussianBlur4 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    stdDeviation: 0.8,
    result: "blur",
    id: "feGaussianBlur21703"
  })), _feOffset4 || (_feOffset4 = /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.6,
    dy: 0.6,
    result: "offset",
    id: "feOffset21705"
  })), _feComposite8 || (_feComposite8 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    operator: "over",
    result: "composite2",
    id: "feComposite21707"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient10021",
    id: "linearGradient10023",
    x1: 52.631748,
    y1: -11.812641,
    x2: 53.075275,
    y2: 64.486969,
    gradientUnits: "userSpaceOnUse"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style171"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#9835D1;}\n\t.st1{fill:none;stroke:#9835D1;stroke-width:4;stroke-miterlimit:10;}\n\t.st2{fill:#9835D1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g63950",
    transform: "matrix(0.64588169,0,0,0.64588169,112.73036,-11.214692)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path245",
    style: {
      fill: "#aad400",
      stroke: "#000000"
    },
    cx: 13.480982,
    cy: 31.798691,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path247",
    style: {
      fill: "#aad400",
      stroke: "#000000"
    },
    cx: 13.480982,
    cy: 31.798691,
    r: 0
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    id: "path6340",
    d: "m -78.780856,44.338242 c -0.0072,-0.02397 -0.01251,-0.04856 -0.02152,-0.0719 -0.05644,-0.14619 -0.1228,-0.270611 -0.18751,-0.416278 -0.177906,-0.400479 -0.33625,-0.808723 -0.494227,-1.217318 -0.335424,-0.902882 -0.510676,-1.850971 -0.612894,-2.805912 -0.0235,-0.219553 -0.03964,-0.439831 -0.05946,-0.659747 -0.07699,-1.060271 -0.107565,-2.123815 -0.102417,-3.186751 0.004,-0.560486 0.04535,-1.119154 0.118685,-1.674575 0,0 -0.0033,-4.3e-5 -0.0033,-4.3e-5 v 0 c -0.07301,0.555458 -0.114303,1.114131 -0.118149,1.674617 -0.0048,1.06295 0.02613,2.12649 0.103079,3.186771 0.01981,0.219918 0.03595,0.440198 0.05943,0.659754 0.102137,0.954944 0.277106,1.903069 0.612473,2.80598 0.157885,0.408574 0.316148,0.816798 0.493733,1.217357 0.06478,0.146128 0.130637,0.269767 0.186979,0.416249 0.009,0.02331 0.01426,0.04786 0.02138,0.0718 0,0 0.0037,0 0.0037,0 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g19382",
    transform: "matrix(0.77157822,0,0,0.80848822,-3.8100943,12.29718)",
    style: {
      fill: "#ffaaaa"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20937",
    transform: "matrix(1.6416004,0,0,1.6416004,-27.189795,-20.046237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path23224",
    transform: "matrix(-0.00885537,0,0,0.0093313,137.06309,17.785929)",
    style: {
      clipRule: "evenodd",
      display: "inline",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      clipRule: "nonzero",
      fill: "#f4a460",
      fillRule: "nonzero",
      strokeWidth: 8.65795,
      InkscapeStroke: "none",
      shapeRendering: "auto"
    },
    d: "m 7990.0049,2149.3256 c -237.2943,191.9841 -508.7046,390.7913 -692.7373,739.5279 l -1.084,2.0528 -1.0234,2.082 c -55.4062,112.6512 -25.9504,173.4676 -9.9434,255.0156 16.0069,81.548 41.9896,173.1607 72.3691,271.7188 60.7592,197.1161 128.717,308.5499 179.2057,482.6823 41.0215,-188.5389 56.3051,-314.8876 104.9768,-549.0557 289.6365,-278.8822 273.5293,-796.9531 353.0441,-948.7024 z",
    id: "path32473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32475",
    style: {
      color: "#000000",
      clipRule: "nonzero",
      fill: "#000000",
      fillRule: "nonzero",
      strokeWidth: 0.0436538,
      InkscapeStroke: "none",
      shapeRendering: "auto"
    },
    d: "m 46.785156,111.88867 c -9.85263,8.80155 -21.348825,18.49167 -29.015625,34.53321 l -0.04492,0.0977 -0.04492,0.0977 c -2.324251,5.21782 -1.087945,8.11042 -0.427735,11.82422 0.66717,3.75295 1.748899,7.95884 3.011719,12.48242 2.52667,9.05081 4.577684,11.56864 6.672224,19.54499 l 0.376503,0.10832 c -0.352907,-1.84575 -5.335806,-14.93326 -6.704977,-19.76855 -1.26135,-4.5183 -2.339143,-8.71691 -3.001953,-12.44531 -0.66976,-3.76755 -1.880893,-6.45332 0.398437,-11.57031 l 0.04102,-0.0937 0.04297,-0.0918 c 7.55198,-15.80128 18.827833,-24.92136 28.626953,-33.65625 z m 0.160156,12.08008 c -2.51823,1.71519 -6.233791,1.0167 -5.925781,19.88867 0.152044,9.31589 -7.177742,9.21395 -7.945312,17.27149 0.02285,-4.5e-4 0.113161,0.025 0.453125,0.16406 0.86253,-8.13174 8.312277,-8.11227 8.117187,-17.38086 -0.33554,-18.7024 3.043119,-17.73449 5.605469,-19.71875 z m -13.871093,37.16016 c 0.453125,0.16406 0.453125,0.16406 0,0 z",
    transform: "matrix(24.070879,0,0,21.800327,6865.6859,-305.20625)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "rect1436",
    style: {
      fill: "#170721",
      fillOpacity: 1,
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M 24.230807,-11.031434 H 83.01765 c 1.262187,0 1.928363,0.923351 2.278316,1.9825222 4.74508,14.3614616 -7.796734,52.6766528 0,71.7362558 0.425413,1.039946 -1.016129,1.98252 -2.278316,1.98252 H 24.230807 c -1.262187,0 -2.071116,-0.897766 -2.278316,-1.98252 -3.89688,-20.401493 6.39641,-54.9499215 0,-71.7362558 -0.399012,-1.0471422 1.016129,-1.9825222 2.278316,-1.9825222 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8621",
    style: {
      fill: "url(#linearGradient10023)",
      fillOpacity: 1,
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M 24.230807,-11.031434 H 83.01765 c 1.262187,0 1.928363,0.923351 2.278316,1.9825222 4.74508,14.3614616 -7.796734,52.6766528 0,71.7362558 0.425413,1.039946 -1.016129,1.98252 -2.278316,1.98252 H 24.230807 c -1.262187,0 -2.071116,-0.897766 -2.278316,-1.98252 -3.89688,-20.401493 6.39641,-54.9499215 0,-71.7362558 -0.399012,-1.0471422 1.016129,-1.9825222 2.278316,-1.9825222 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      clipRule: "nonzero",
      display: "inline",
      fill: "#f4a460",
      fillRule: "nonzero",
      strokeWidth: 0.1292,
      strokeLinecap: "round",
      InkscapeStroke: "none",
      imageRendering: "optimizeQuality",
      shapeRendering: "auto",
      textRendering: "geometricPrecision"
    },
    d: "m 81.653045,45.861492 c 0.478105,0.01989 1.325627,1.076469 1.63718,2.721579 0.383514,2.025042 0.18641,4.761833 0.294655,5.371903 0.690076,1.45187 2.168945,2.218471 2.719262,4.161324 1.469647,5.188493 2.607732,11.431125 2.723722,18.209919 l -8.766926,-0.006 c 0.608691,-7.600738 -1.824434,-8.403642 -2.655004,-12.755245 -0.550927,-2.886523 3.156961,-9.100386 1.637506,-14.811386 -0.342326,-1.286651 0.656501,-2.608247 1.898596,-2.85297 0.168408,-0.03318 0.339813,-0.04631 0.511009,-0.03916 z",
    id: "path40078"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      clipRule: "nonzero",
      display: "inline",
      fill: "#000000",
      fillRule: "nonzero",
      strokeWidth: 0.0149222,
      strokeLinecap: "round",
      InkscapeStroke: "none",
      imageRendering: "optimizeQuality",
      shapeRendering: "auto",
      textRendering: "geometricPrecision"
    },
    d: "m 88.581026,68.073782 c 0,0 -0.06155,0.156723 -0.05299,0.219293 0.752598,5.511528 0.643022,8.033142 0.643022,8.033142 l -0.135743,-0.0042 c -0.112054,-3.99199 -0.441106,-6.867475 -0.605491,-7.887845 -0.01591,-0.0992 0.01947,-0.324147 0.01947,-0.324147 M 82.886446,47.251034 c -0.03858,0.01494 -0.418348,-1.20688 -1.339454,-1.295335 -0.165803,-0.01591 -0.308348,0.01774 -0.472128,0.04996 -1.208643,0.238134 -2.110874,1.484298 -1.779468,2.729906 0.764924,2.875015 0.213672,5.868407 -0.455361,8.49993 -0.669029,2.631521 -1.449409,4.910219 -1.181045,6.316266 0.823081,4.312367 3.18482,4.793221 2.601948,12.768472 l -0.11942,-6.04e-4 c 0.558576,-7.987928 -1.769916,-8.361523 -2.605932,-12.741676 -0.282566,-1.480474 0.515545,-3.751951 1.182863,-6.37673 0.667319,-2.62479 1.210291,-5.593854 0.455759,-8.42983 -0.353245,-1.327691 0.602001,-2.644763 1.877538,-2.896077 0.129785,-0.02556 0.26127,-0.03957 0.393125,-0.04186 0.04392,-7.89e-4 0.08794,-2.49e-4 0.131931,0.0018 0.433826,-0.045 0.879461,0.359938 1.32508,1.089581",
    id: "path33713"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6405",
    style: {
      fill: "#eeddb9",
      fillOpacity: 1,
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 60.99546,4.4500035 c -2.539639,-0.4837407 -5.184583,7.8559175 -6.161009,15.7445805 -0.06656,0.537733 -0.149136,1.209521 -0.149136,1.209521 -0.0027,0.01497 -1.175138,-0.15289 -1.175138,-0.15289 l -0.991499,0.829273 -0.713282,-0.755469 c 0,0 -0.723045,0.894377 -0.724702,0.912427 -0.002,0.0217 -0.326557,2.571838 -0.326557,2.571838 l 1.489163,-0.08792 1.266335,-0.974858 c 0,0 0.916129,0.590925 0.910557,0.661795 -0.167448,2.129732 -0.07673,2.697433 -0.01492,4.81782 0.262024,8.988535 3.954892,17.09933 5.803921,25.675151 -0.007,0.268738 0.07888,2.122871 0.07888,2.122871 L 52.706105,55.31259 c 1.580039,-2.631091 -3.798988,-10.737566 -3.008582,-21.127451 0.187553,-2.465386 0.761941,-7.095751 1.386174,-11.952466 0.766425,-5.963016 1.607989,-12.2672464 1.900975,-15.3245855 0.568544,-5.93281979 -3.723886,2.5019922 -6.966295,-5.695683 -0.35638,-0.901023 0.05047,-2.916245 1.444638,-4.0555611 5.31867,-4.3463027 7.766095,4.3703861 8.184365,3.1778981 0.788193,-2.2471156 5.371699,-1.7057805 5.517672,1.479051 0.04016,0.87761 -0.169571,2.636206 -0.169571,2.636215 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanit);
export default __webpack_public_path__ + "static/media/planit.cc7f48284faffa38c13a46f53737cb8e.svg";
export { ForwardRef as ReactComponent };